<template>
        <tr>
            <input type="hidden"
                   :name="'recruit[' + recruit.category_id + ']['+  recruit.recruit_id +'][sort_no]'"
                   v-model="recruit.sort_no">

            <td class="nowrap drag_handle" width="5%"><i class="fa fa-align-justify"></i></td>
            <td width="30%">
                <div class="text--bold" v-if="recruit.recruit_master_id">
                    {{ recruit.recruit_name }}
                    <input type="hidden"
                        :name="'recruit[' + recruit.category_id + ']['+  recruit.recruit_id +'][recruit_name]'"
                        :value="recruit.recruit_name">
                    <input type="hidden"
                        :name="'recruit[' + recruit.category_id + ']['+  recruit.recruit_id +'][recruit_master_id]'"
                        :value="recruit.recruit_master_id">
                </div>
                <input v-else
                       type="text"
                       :name="'recruit[' + recruit.category_id + ']['+  recruit.recruit_id +'][recruit_name]'"
                       :id="'recruit_name_' + recruit.recruit_id"
                       class="form-control"
                       v-model="recruit.recruit_name" maxlength="255" placeholder="項目名">
                <label class="m-t-sm">
                    <input type="checkbox" :name="'recruit[' + recruit.category_id + ']['+  recruit.recruit_id +'][item_public_flg]'" v-model="recruit.item_public_flg">
                    &ensp;掲載する
                </label>
            </td>
            <td width="55%">
               <textarea rows="3"
                         :name="'recruit[' + recruit.category_id + ']['+  recruit.recruit_id +'][recruit_info]'"
                         :id="'recruit_info_' + recruit.recruit_id"
                         class="form-control"
                         v-model="recruit.recruit_info" maxlength="1000"
                         :placeholder="recruit.recruit_master_id ? getNameById(recruit.recruit_master_id) : '項目の詳細文'"></textarea>
            </td>
            <td class="no_dragover" width="10%">
                <a class="m-l-xs btn-delete" data-toggle="modal"
                   :data-target="'#dialog_delete_item_'+ recruit_group_key + '_' + recruit.recruit_id">
                <button class="btn btn-primary btn-xs" type="button"
                        v-if="(!recruit.recruit_master_id)">
                    <i class="fa fa-trash"></i>
                    削除
                </button>
                </a>
            </td>
            <!-- 削除ダイアログ -->
            <div class="modal fade inmodal" role="dialog"
                 :id="'dialog_delete_item_'+ recruit_group_key + '_' + recruit.recruit_id" tabindex="-1">
                <div class="modal-dialog modal-lg">
                    <div class="modal-content">
                        <div class="modal-header">
                            <button type="button" class="close" data-dismiss="modal"
                                    aria-label="Close"><span aria-hidden="true">×</span></button>
                            <i class="fa fa-trash modal-icon"></i>
                            <h4 class="modal-title">削除の確認</h4>
                        </div>
                        <div class="modal-body">
                            <p v-show="recruit.recruit_name">『{{ recruit.recruit_name }}』を削除してもよろしいですか？</p>
                            <p v-show="!recruit.recruit_name">該当の項目を削除してもよろしいですか？</p>
                        </div>
                        <div class="modal-footer">
                            <button type="button" class="btn btn-default pull-left"
                                    data-dismiss="modal">キャンセル
                            </button>
                            <button type="button" class="btn btn-primary"
                                    @click="emitEvent(recruit_group_key, recruit_item_key, '#dialog_delete_item_'+ recruit_group_key + '_' + recruit.recruit_id)">
                                実行する
                            </button>

                        </div>
                    </div>
                </div>
            </div>
        </tr>
</template>
<script>

export default {
    props: ['recruit', 'recruit_item_key', 'recruit_group_key', 'errors', 'recruit_master'],
    methods: {
        emitEvent(recruit_group_key, recruit_item_key, modal_name) {
            this.$emit('recruit-emit', {recruit_group_key: recruit_group_key, recruit_item_key: recruit_item_key, modal_name: modal_name })
        },
        getNameById(id) {
            const master = this.recruit_master.find(master => master.id === id);
            return master ? master.contents : '';
        }
    }
}
</script>
